import {APIClient} from '../utils/APIClient';
import {isOk} from '../utils/apiResponse';
import {API_URL} from '../settings/local_settings';

// «Lo que la línea deja afuera» por su regla de campañas (tanda «Control de líneas», 15/10). Lo que no cuenta
// ninguna línea en una cuenta vive en «Inversión sin control» (`uncontrolledSpendApi.js`, UD-5 del 17/10).
//
// `GET business-unit/<id>/uncovered-spend/` → `{status: 'OK', data: {amount, currency, campaign_count, date,
// total_budget, completion, level, rules, campaigns, rule_leak}}` (contrato §2.1). Sin snapshot, o con la
// línea en «todas las campañas», `{status: 'OK'}` sin `data`. Lee el snapshot del sync: no calcula.
//
// «No hace falta controlarla» y su «Deshacer» reusan los endpoints de «Inversión sin control»
// (`uncontrolledSpendApi.js`, `alert-snooze`), para que sean las MISMAS filas: un descarte silencia el chip
// y la solapa «Inversión sin control».
const PATH = 'uncovered-spend/';
const UNCONTROLLED_PATH = 'agency/uncontrolled-spend/';

export const UncoveredSpendApi = {
    // Con cache de 30 s: el panel del cliente se remonta al volver de otra solapa.
    forLine(businessUnitId) {
        return new APIClient(`${API_URL}business-unit/${businessUnitId}/${PATH}`).call('GET', {}, {cache: true});
    },

    // Tras una acción, lo cacheado ya no es lo que se ve: el detalle de la línea y el resumen de «Inversión
    // sin control» (la tarjeta del Tablero, la ficha, el Listado y «Ahora»). `clearCache` borra por substring.
    clearCache() {
        APIClient.clearCache(PATH);
        APIClient.clearCache(UNCONTROLLED_PATH);
    },
};

/** El objeto de la línea, o `null` si no hay nada que mostrar (o la respuesta no es OK). */
export function uncoveredFromResponse(response) {
    if (!isOk(response)) return null;
    return response.data || null;
}
